"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author tatevik.marikyan
 * @since 23/07/2018
 */
var core_1 = require("@angular/core");
var idm_validation_calculation_service_client_js_1 = require("@synisys/idm-validation-calculation-service-client-js");
var SisValidationMessagePipe = /** @class */ (function () {
    function SisValidationMessagePipe() {
    }
    SisValidationMessagePipe.prototype.transform = function (validations, fieldSystemName, currentLanguageId) {
        var _this = this;
        if (!validations) {
            return undefined;
        }
        else {
            var validation = validations.find(function (validationItem) {
                return !!_this.getDisplayFields(validationItem).find(function (displayForField) { return displayForField === fieldSystemName; });
            });
            return (validation &&
                validation.getMessage().getValue(currentLanguageId));
        }
    };
    SisValidationMessagePipe.prototype.getDisplayFields = function (validation) {
        if (validation.getValidationDisplay() &&
            validation.getValidationDisplay().getFields() &&
            validation.getValidationDisplay().getDisplayType() ===
                idm_validation_calculation_service_client_js_1.ValidationDisplayType.FIELDS) {
            var fields = validation
                .getValidationDisplay()
                .getFields()
                .get('fields');
            if (!fields) {
                return [];
            }
            return Array.isArray(fields) ? fields : fields.fields || [];
        }
        else {
            return validation
                .getRelatedMetaFieldIds()
                .map(function (metaField) { return metaField.getSystemName(); });
        }
    };
    SisValidationMessagePipe = __decorate([
        core_1.Pipe({
            name: 'sisValidationMessage',
            pure: true,
        })
    ], SisValidationMessagePipe);
    return SisValidationMessagePipe;
}());
exports.SisValidationMessagePipe = SisValidationMessagePipe;
//# sourceMappingURL=sis-validation-message.pipe.js.map